import { Capacitor } from '@capacitor/core';
import { initializeApp } from 'firebase/app';
import { Analytics, getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDSULoi9912VuvGPRl-zjLbbSJegXjiXDE',
  // 'turaq.kg' once https://turaq.kg/__/auth/handler is registered with Google
  // (OAuth client) and Apple (Services ID) — netlify.toml proxies /__/auth/*.
  // Same-site auth domain is what makes redirect sign-in work on iOS.
  authDomain: (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined) || 'turaq-kg.firebaseapp.com',
  projectId: 'turaq-kg',
  storageBucket: 'turaq-kg.firebasestorage.app',
  messagingSenderId: '1071788888872',
  appId: '1:1071788888872:web:edb46815b200f95399f61d',
  measurementId: 'G-RR0SPG26Y4',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Firebase Analytics bundles its own web-vitals-style performance reporter
// (`reportAllChanges`). In contexts where it isn't actually supported —
// Capacitor's WebView, bfcache restores, privacy browsers — it throws an
// uncaught "Cannot read properties of undefined (reading 'startTime')".
// Initialise it lazily, never in the native app, and only once the SDK
// confirms support.
let analytics: Analytics | null = null;

if (!Capacitor.isNativePlatform() && typeof window !== 'undefined') {
  // Google Analytics pulls ~160 KB of gtag.js: start it once the page has
  // loaded and the browser is idle, so it never competes with the first paint.
  const start = () =>
    isSupported()
      .then((supported) => {
        if (supported) analytics = getAnalytics(app);
      })
      .catch(() => {
        /* analytics unavailable in this environment — ignore */
      });
  const idle = () => {
    const w = window as Window & { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number };
    if (w.requestIdleCallback) w.requestIdleCallback(() => void start(), { timeout: 4000 });
    else setTimeout(() => void start(), 2500);
  };
  if (document.readyState === 'complete') idle();
  else window.addEventListener('load', idle, { once: true });
}

export { app, analytics, auth };
